import { Table } from '@repo/database/src/types';

import { SeatDto } from './table-types';

export interface HandHistoryState {
  id: string;
  state: string;
  seats: (SeatDto | null)[];
  playerSeat: SeatDto | null | undefined;
  handState: {
    lastOperation: {
      subtype: string;
    };
  };
  /** Enriched by the server so the client can display the timestamp for each state. */
  createdAt?: Date;
}

export interface TableHandMap {
  [key: string]: Table & {
    hands: string[];
  };
}
